"use strict";
// vocechat 访客端 SDK 数据结构 —— 与 IM WebSocket 访客协议对接。
// 权威来源: visitor-api-integration-guide.md v1.0 (2026-10-28)。
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVocechatMessageType = getVocechatMessageType;
/** 按 content_type 归类消息(见访客 IM 接口文档)。 */
function getVocechatMessageType(contentType) {
    if (contentType.startsWith('image/'))
        return 'image';
    if (contentType.startsWith('video/'))
        return 'video';
    if (contentType === 'vocechat/file')
        return 'file';
    return 'text';
}
//# sourceMappingURL=vocechat-visitor.js.map